export default {
  logout: 'ログアウト',
  language: '言語',
  collapse: '折りたたむ',
  welcome: 'ようこそ',
  download: 'ダウンロード',
  delete: '削除',
  upload: 'アップロード',
  submit: '提出',
  cancel: 'キャンセル',
  close: '閉鎖',
  confirm: '確定',
  ok: 'OK',
  edit: '編集',
  save: '保存',
  reset: '初期化',
  search: '検索',
  view: '閲覧',
  detail: '詳細',
  success: '保存しました',
  failed: '保存に失敗しました',
  loading: '読み込み中...',
  uploading: 'アップロード中...',
  downloading: 'ダウンロード中...',
  downloadStarted: 'ダウンロード開始',
  actions: '操作',
  downloadSuccess: 'ダウンロード成功',
  deleteSuccess: '削除成功',
  uploadSuccess: 'アップロード成功',
  uploadFailed: 'アップロード失敗',
  chooseFile: 'ファイルを選択',
  chooseFileFromCompany: '企業の常用資料から必要なファイルを選択してください',
  addFile: 'ファイルを追加',
  manageFiles: '資料管理',
  emptyFileMessage: 'まだ追加されていません。企業の常用資料を先に管理してください',
  fileName: 'ファイル名',
  uploadTime: 'アップロード時間',
  fileSize: 'ファイルサイズ',
  prev: '前へ',
  next: '次へ',
  saveAndOut: '保存して終了',
  tableStats: '合計: #total# 件',
  fileFormatNotSupported: 'ファイル形式がサポートされていません。{0} 形式のファイルをアップロードしてください',
  fileSizeExceeded: 'ファイルサイズは {0} MB を超えることはできません',
  confirmLeave: {
    title: 'このページから離れますか？',
    content: '変更内容はまだ保存されていません。本当に離れますか？',
  },
  confirmDeleteEmployee: {
    title: '従業員を削除しますか？',
    content: '削除後は元に戻せません。従業員『{0}』を削除してもよろしいですか？',
  },
  cannotDeleteEmployee: {
    title: '従業員の削除エラー',
    content: 'この従業員には未完了の手続きがあるため、削除できません。',
    confirm: 'わかりました',
  },
  confirmDeleteFile: {
    title: 'ファイルを削除しますか？',
    content: '削除後は元に戻せません。ファイル『{0}』を削除してもよろしいですか？',
  },
  deleteConfirm: {
    title: '削除しますか？',
    taskContent: '削除後は元に戻せません。タスク『{name}-{number}』を削除してもよろしいですか？',
  },
  tokenExpired: 'ログインの有効期限が切れました。もう一度ログインしてください。',
  saveSuccess: '保存に成功しました',
  saveFailed: '保存失敗',
  cancelSuccess: 'キャンセルに成功しました',
  confirmDelete: '削除の確認',
  operationFailed: '操作失敗',
  mapDialog: {
    title: '地図で指定',
    searchPlaceholder: '住所検索',
    noAddressSelected: '住所未選択',
    confirmLocationTip: '位置を確認してください。正確な位置でないと求職者が迷う可能性があります',
    addressUpdated: '住所が更新されました',
    searchAddressFirst: '検索ボックスに住所を入力してください',
  },
  addressSelector: {
    provincePlaceholder: '都道府県',
    detailPlaceholder: '市町村区、番地、建物名、階数など',
    mapLocation: '地図で指定',
  },
  pleaseSelect: '選択してください',
  to: '〜',
  startDate: '開始日',
  endDate: '終了日',
  total: '合計',
  items: '件',
  fetchFailed: 'データの取得に失敗しました',
  loadFailed: '読み込みに失敗しました',
  deleteConfirmMessage: '削除後は元に戻せません。本当に削除しますか？',
  warning: '警告',
  deleteFailed: '削除に失敗しました',
  addSuccess: '追加に成功しました',
  imgUpload: {
    view: '閲覧',
    download: 'ダウンロード',
    viewExample: '例を見る',
    downloadTemplate: 'テンプレートをダウンロード',
    fileFormatNotSupported: 'ファイル形式がサポートされていません。{formats} 形式のファイルをアップロードしてください',
    onlyImageAllowed: '画像ファイルのみアップロード可能です',
    fileTooLarge: 'ファイルサイズは {size} を超えることはできません',
    downloadSuccess: 'ダウンロード成功',
    loadFailed: '画像の読み込みに失敗しました',
  },
  yes: 'はい',
  no: 'いいえ',
  noData: 'データなし',
  currency: {
    jpy: '円',
  },
  units: {
    days: '日',
    hours: '時間',
    people: '人',
    years: '年',
    months: 'ヶ月',
  },
  noAccessPermission: 'アクセス権限 なし',
  nextDay: '翌日',
};
